var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHostIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.941 8.04a2.503 2.503 0 00-3.084-2.956A3.005 3.005 0 008 3a3.008 3.008 0 00-2.88 2.158A4.004 4.004 0 000 9c0 2.206 1.794 4 4 4h9.5c1.379 0 2.5-1.121 2.5-2.5 0-1.228-.89-2.251-2.059-2.46zM13.5 12H4c-1.654 0-3-1.346-3-3s1.346-3 3-3c.813 0 1.574.32 2.143.9a.5.5 0 00.714-.7 4.037 4.037 0 00-.809-.638A2.005 2.005 0 018 4a2.002 2.002 0 011.959 2.404.5.5 0 10.98.2 2.99 2.99 0 00.06-.518A1.502 1.502 0 0112.914 8H12.5a.5.5 0 000 1h1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostIcon);
export default __webpack_public_path__ + "static/media/host-icon.7a569aa94301586996c92f9025b42f26.svg";
export { ForwardRef as ReactComponent };